/** How long a recorded note may run, by kind, for the host and for a guest alike: null is no limit. */
export const NOTE_MAX_SEC = { voice: null, video: 600 } as const;
